export function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export function postPopup(popup) {
  popup.querySelector("button.submit img").src =
    "https://" +
    window.location.hostname +
    "/wp-content/themes/vanthul/dist/images/ripple_loader.gif";

  var mail = document.getElementById("popup-newsletter-form-mail").value;

  if (typeof _agile !== "undefined") {
    _agile.set_email(mail);
  }

  var name = document.getElementById("popup-newsletter-form-name").value;
  var company = document.getElementById("popup-newsletter-form-company").value;
  var installatiebedrijf = document.getElementById("popup-nieuwsbrief-checkbox")
    .checked;

  var tags = [];
  if (installatiebedrijf) {
    tags.push("Installatiebedrijf");
  }

  tags.push("Popup");
  tags.push("Nieuwsbrief");

  var dialog = document.getElementById("popup-newsletter-dialog");

  if (!dialog) {
    var dialog = document.createElement("div");
    dialog.setAttribute("id", "popup-newsletter-dialog");
    document
      .getElementById("popup-nieuwsbrief-checkbox-container")
      .appendChild(dialog);
  }

  if (mail == "" || name == "" || company == "") {
    dialog.innerHTML = "Vul alle velden in";
    popup.querySelector("button.submit img").src =
      "https://" +
      window.location.hostname +
      "/wp-content/themes/vanthul/dist/images/arrow.svg";
    return;
  }

  if (!validateEmail(mail)) {
    dialog.innerHTML = "Vul een geldig emailadres in";
    popup.querySelector("button.submit img").src =
      "https://" +
      window.location.hostname +
      "/wp-content/themes/vanthul/dist/images/arrow.svg";
    return;
  }

  var request = new XMLHttpRequest();
  request.open("POST", ajaxurl.ajax_url, true);
  request.setRequestHeader(
    "Content-Type",
    "application/x-www-form-urlencoded; charset=UTF-8"
  );
  request.onload = function() {
    if (this.status >= 200 && this.status < 400) {
      // If successful
      popup.querySelector("button.submit img").src =
        "https://" +
        window.location.hostname +
        "/wp-content/themes/vanthul/dist/images/arrow.svg";

      dialog.innerHTML = "Bedankt voor het invullen!";
    } else {
      // If fail
      console.error(request);
    }
  };
  request.onerror = function() {
    // Connection error
  };
  request.send(
    "action=update_or_create_user_agile&contact=" +
      encodeURIComponent(
        JSON.stringify({
          mail: mail,
          name: name,
          company: company,
          tags: tags,
          form: "popup",
        })
      )
  );
}

export function getCookie(name) {
  var value = "; " + document.cookie;
  var parts = value.split("; " + name + "=");
  if (parts.length == 2)
    return parts
      .pop()
      .split(";")
      .shift();
}

function validateEmail(email) {
  var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}
